import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Content} from 'shared/models/contents/content';
import {IContentsDetailsRepository} from '../repositories/contents-details.repository.interface';
import { TargetGroup } from 'shared/models/target-groups/target-group';
import { Dialog } from 'shared/classes/dialog';

@Injectable()
export class ContentsDetailsService {

  constructor(@Inject('IContentsDetailsRepository') private contentsDetailsRepository: IContentsDetailsRepository) { }

  public getContents(): Observable<Array<Content>> {
    return this.contentsDetailsRepository.getContents();
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    return this.contentsDetailsRepository.getAllTargetGroups();
  }

  public getDialogs(): Observable<Array<Dialog>> {
    return this.contentsDetailsRepository.getDialogs();
  }

  public getContent(id: string): Observable<Content> {
    return this.contentsDetailsRepository.getContent(id);
  }

  public saveContent(content: Content): Observable<Content> {
    return this.contentsDetailsRepository.saveContent(content);
  }

  public updateContent(content: Content): Observable<Content> {
    return this.contentsDetailsRepository.updateContent(content);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/contents/contents-details/services/contents-details.service.ts